export const FARM_NAME = "KSR Poultry Farms";
export const LOCATION = "Mansampalle, Vikarabad, Telangana";
export const CONTACT_NAME = "Qaiser";
export const PHONE_DISPLAY = "+91 94407 37185";
export const PHONE_TEL = "tel:+919440737185";
export const EMAIL = "info@ksrpoultryfarms.com";
export const EMAIL_MAILTO = "mailto:info@ksrpoultryfarms.com";

const WA_MESSAGE =
  "Hi, I'm interested in wholesale egg supply. Please share today's rate and availability.";

export const WHATSAPP_URL = `https://wa.me/919440737185?text=${encodeURIComponent(WA_MESSAGE)}`;

// Registered Google Maps place (plus code 7J9V8P54+P9, CID
// 16444503927862938749). Google has no road data reaching the farm, so it
// offers a route preview but never a Start button — tested with coordinates,
// with the plus code and with dir_action=navigate. Linking the place at least
// shows the farm by name with its pin, and the customer can take the route
// preview from there.
export const MAPS_URL = "https://maps.google.com/?cid=16444503927862938749";

export const CONTACT2_NAME = "Venkat";
export const PHONE2_DISPLAY = "+91 96661 94569";
export const PHONE2_TEL = "tel:+919666194569";
export const WHATSAPP2_URL = `https://wa.me/919666194569?text=${encodeURIComponent(WA_MESSAGE)}`;

// UPI — PhonePe address for KSR Poultry Farms, Yes Bank handle (@ybl).
// Use @ybl, not @ibl: only @ybl resolves to the business name in payers' UPI
// apps, which is what the payee-name check in Payment.jsx relies on.
// UPI_URL is the exact string encoded in public/upi-qr.svg; keep the two in sync.
export const UPI_ID = "7013759703-3@ybl";
export const UPI_PAYEE_NAME = "KSR POULTRY FARMS";
const UPI_PARAMS = "pa=7013759703-3@ybl&pn=KSR%20POULTRY%20FARMS&cu=INR";

// Generic UPI intent. Android shows an app chooser; iOS does not — it picks a
// single handler with no way to choose, which lands on WhatsApp Pay. Hence the
// named links below, so a customer can reach the app they actually use.
export const UPI_URL = `upi://pay?${UPI_PARAMS}`;

export const UPI_APPS = [
  { name: "PhonePe", url: `phonepe://pay?${UPI_PARAMS}` },
  { name: "Google Pay", url: `tez://upi/pay?${UPI_PARAMS}` },
  { name: "Paytm", url: `paytmmp://pay?${UPI_PARAMS}` },
];

// Bank transfer — UBI current account, Vikarabad branch (IFSC verified against
// the public IFSC directory: Union Bank of India, VIKARABAD, NEFT/RTGS/IMPS).
export const BANK_NAME = "Union Bank of India";
export const BANK_BRANCH = "Vikarabad";
export const BANK_ACCOUNT_NAME = "KSR POULTRY FARMS";
export const BANK_ACCOUNT_NUMBER = "061311010000109";
export const BANK_IFSC = "UBIN0806137";
